var map = {
	"./account-icon-active.svg": "ce9e",
	"./account-icon-dark.svg": "9a9c",
	"./account-icon.svg": "6f47",
	"./ax-icon-active.svg": "75f3",
	"./ax-icon.svg": "60cc",
	"./close-icon--dark.svg": "af97",
	"./close-icon-dark.svg": "1b36",
	"./close-icon.svg": "d144",
	"./closebtn-icon-active.svg": "871e",
	"./closebtn-icon.svg": "a9f7",
	"./config-account-icon.svg": "2bf9",
	"./dark-mode-icon-active.svg": "39c0",
	"./dark-mode-icon-dark.svg": "8261",
	"./dark-mode-icon.svg": "31cb",
	"./document-icon-active.svg": "7c94",
	"./document-icon-dark.svg": "ca2c",
	"./document-icon.svg": "6647",
	"./download-icon-active.svg": "22e8",
	"./download-icon-dark.svg": "81f6",
	"./download-icon.svg": "8d12",
	"./folios-icon-active.svg": "f922",
	"./folios-icon-dark.svg": "57da",
	"./folios-icon.svg": "6ca4",
	"./help-icon-active.svg": "2b97",
	"./help-icon-dark.svg": "31ee",
	"./help-icon.svg": "da59",
	"./home-icon-active.svg": "2cf1",
	"./home-icon-dark.svg": "4ee4",
	"./home-icon.svg": "3177",
	"./metrics-icon-active.svg": "d66c",
	"./metrics-icon-dark.svg": "1865",
	"./metrics-icon.svg": "7819",
	"./open-icon--dark.svg": "aa59",
	"./open-icon.svg": "eb57",
	"./pos-icon-active.svg": "cb7e",
	"./pos-icon-dark.svg": "0e60",
	"./pos-icon.svg": "e602",
	"./purchase-icon-active.svg": "68ba",
	"./purchase-icon-dark.svg": "dea0",
	"./purchase-icon.svg": "8a00",
	"./report-icon-active.svg": "bb9b",
	"./report-icon-dark.svg": "e5ae",
	"./report-icon.svg": "2957"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9cab";